<template>
	<div class="slider-container">
		<button v-if="slideButtons" class="prev-btn" @click="prevSlide">❮</button>
		<div class="slider">
			<img
				class="post-preview-card__thumbnail u-cursor-pointer"
				:src="photos[currentIndex]"
				alt="thread image"
				loading="lazy"
				@click="openModal(currentIndex)"
			/>
		</div>
		<button v-if="slideButtons" class="next-btn" @click="nextSlide">❯</button>
		<div v-if="photos.length > 1" class="dots-container">
			<span
				v-for="(photo, index) in photos"
				:key="index"
				class="dot"
				:class="{ active: index === currentIndex }"
				@click="goToSlide(index)"
			>
			</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'PhotoSlider',
	data() {
		return {
			currentIndex: 0,
		}
	},
	props: {
		photos: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		photos: {
			handler(newPhotos) {
				if (!newPhotos.length) {
					this.currentIndex = 0
					return
				}

				if (this.currentIndex > newPhotos.length - 1) {
					this.currentIndex = newPhotos.length - 1
				}
			},
			immediate: true,
		},
	},
	methods: {
		openModal(index) {
			this.$emit('openModal', index)
		},
		nextSlide() {
			this.currentIndex = (this.currentIndex + 1) % this.photos.length
		},
		prevSlide() {
			this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length
		},
		goToSlide(index) {
			this.currentIndex = index
		},
	},
	computed: {
		slideButtons() {
			return this.photos.length > 1
		},
	},
}
</script>
